<template>
  <div class="MR_roadClean" ref="MR_roadClean" @click="rowClick">
    <div class="sweeperBg"></div>
    <ul>
      <li>
        <div class="li_count bigTitle">{{ todayMoisturizeTimes }}</div>
        <div class="li_title">今日保湿次数</div>
      </li>
      <li>
        <div class="li_count">{{ todayCleanDistance }}</div>
        <div class="li_unit">km</div>
        <div class="li_title">环保车今日清洁里程</div>
      </li>
      <li>
        <div class="li_count bigTitle">{{ todayCleanupTimes }}</div>
        <div class="li_title">今日清扫次数</div>
      </li>
    </ul>
  </div>
</template>

<script>
import MR_roadCleanPup from "@/modules/mathRoadComponents/MR_roadCleanPup/MR_roadCleanPup.vue";
import { mapGetters } from "vuex";

export default {
  props: ["matrix", "x", "y"],
  data() {
    return {
      pageInfo: 'MR_roadClean.vue',
      computedName: '道路清洁组件',
      customerId: this.$store.state.customerId,
      todayCleanDistance: 0,
      todayCleanupTimes: 0,
      todayMoisturizeTimes: 0,
      setTime1: null,
    };
  },
  computed: {
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
  },
  mounted() {
    let that = this;
    let w = $(that.$refs.MR_roadClean).outerWidth();
    let h = $(that.$refs.MR_roadClean).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getListData();
  },
  unmounted() {
    if (this.setTime1) {
      clearTimeout(this.setTime1);
      this.setTime1 = null;
    }
  },
  methods: {
    async getListData() {
      if (this.setTime1) {
        clearTimeout(this.setTime1);
        this.setTime1 = null;
      }
      let cleaninfo = CONFIG.requestName + this.$apiOpt.cleaninfo;
      let res = await this.$apiUtils.get(cleaninfo, {
        customerId: this.customerId,
      });
      if (res) {
        let { todayCleanDistance, todayCleanupTimes, todayMoisturizeTimes } =
          res;
        this.todayCleanDistance = todayCleanDistance;
        this.todayCleanupTimes = todayCleanupTimes;
        this.todayMoisturizeTimes = todayMoisturizeTimes;
        console.log("res999", res);
      }
      this.setTime1 = setTimeout(() => {
        this.getListData();
      }, 60 * 1000 * 30);
    },
    rowClick() {
      this.$store.commit("dialogStatus", true);
      this.$popup.open(MR_roadCleanPup, this.dialogCompontent, {pageTitleName: '道路清洁'});
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.MR_roadClean {
  height: 250px;
  width: 600px;
  z-index: 9999;
  .sweeperBg {
    @include bg-box(560px, 178px, "sweeperBg.png");
    margin-top: 32px;
    position: absolute;
  }
  ul {
    height: 100%;
    padding-top: 35px;
    display: flex;
    li {
      z-index: 2;
      flex: 170;
      .li_count {
        height: 140px;
        padding-top: 10px;
        line-height: 130px;
        font-size: 25px;
        text-align: center;
      }
      .li_title {
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #c1eef3;
        line-height: 20px;
        text-align: center;
      }
    }
    li:nth-child(2) {
      flex: 186;
      .li_count {
        height: 140px;
        padding-top: 10px;
        line-height: 120px;
        font-size: 26px;
        text-align: center;
        color: white;
      }
      .li_unit {
        position: absolute;
        top: 60%;
        left: 49%;
        font-size: 12px;
      }
    }
  }
}
</style>
